import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { AuraMax } from './pages/AuraMax';
import { Profile } from './pages/Profile';
import { Settings } from './pages/Settings';
import { Navigation } from './components/Navigation';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col w-full min-h-screen hero-bg font-sans mx-auto relative" data-id="element-1">
        <div className="flex-1 pt-safe pb-16 overflow-y-auto" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
            <Route path="/auramax" element={<AuraMax data-id="element-7" />} data-id="element-6" />
            <Route path="/profile" element={<Profile data-id="element-9" />} data-id="element-8" />
            <Route path="/settings" element={<Settings data-id="element-11" />} data-id="element-10" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-13" />} data-id="element-12" />
          </Routes>
        </div>
        <Navigation data-id="element-14" />
      </div>
    </BrowserRouter>;
}